'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import { GalleryImageType } from '@/types/restResponses/steps';
import Icon from '@/ui/components/Icon';
import { ManualPhotoArrows, ManualPhotoButton, ManualPhotoPulse } from '@/ui/components/Manual/manual.styled';

interface NavigationProps {
  isTabOpen: boolean;
  activePhoto?: number;
  hasPrevSlideOrStep?: boolean;
  hasNextSlideOrStep?: boolean;
  currentStepGallery?: GalleryImageType[] | null;
  currentStepVideo?: string | null;
  prevSlide?: () => void;
  nextSlide?: () => void;
  prevStep?: () => void;
  nextStep?: () => void;
  isLoading?: boolean;
}

const Navigation: React.FC<NavigationProps> = ({
  isTabOpen,
  activePhoto,
  hasPrevSlideOrStep,
  hasNextSlideOrStep,
  currentStepGallery,
  currentStepVideo,
  prevSlide,
  nextSlide,
  prevStep,
  nextStep,
  isLoading = false,
}) => {
  const t = useTranslations();

  if (isLoading) {
    return (
      <ManualPhotoArrows $isTabOpen={isTabOpen}>
        <ManualPhotoPulse>
          <div className="pulse" />
        </ManualPhotoPulse>
      </ManualPhotoArrows>
    );
  }

  return (
    <ManualPhotoArrows $isTabOpen={isTabOpen}>
      <ManualPhotoButton $disabled={!hasPrevSlideOrStep} onClick={prevSlide}>
        <Icon style="solid" name="backward" size="lg" />
      </ManualPhotoButton>
      <ManualPhotoButton
        $disabled={!hasPrevSlideOrStep && activePhoto === 0}
        onClick={!currentStepGallery && currentStepVideo ? prevSlide : prevStep}
      >
        <Icon style="solid" name="left" size="lg" />
      </ManualPhotoButton>
      <ManualPhotoButton
        $disabled={!hasNextSlideOrStep && (currentStepGallery ? currentStepGallery.length - 1 === activePhoto : false)}
        $orange={true}
        $wide={true}
        onClick={!currentStepGallery && currentStepVideo ? nextSlide : nextStep}
      >
        <span>{t('manual-button-next')}</span>
        <Icon style="solid" name="right" size="lg" />
      </ManualPhotoButton>
      <ManualPhotoButton $disabled={!hasNextSlideOrStep} onClick={nextSlide}>
        <Icon style="solid" name="forward" size="lg" />
      </ManualPhotoButton>
    </ManualPhotoArrows>
  );
};

export default Navigation;
